import * as R from 'ramda'
import {
  RECEIVE_ERROR,
  RECEIVE_ONE_SCHOOL_FLYER,
  REQUEST_DISTRICT_FLYERS,
  RECEIVE_DISTRICT_FLYERS,
  RECEIVE_ONE_DISTRICT_FLYER,
  RETRIEVE_DISTRICT_FLYERS_FROM_CACHE
} from './actions'

export const reducer = (
  state = {
    isFetching: false,
    error: '',
    lastUpdated: 0,
    allIds: [],
    byCategory: {},
    allCategories: []
  },
  action
) => {
  switch (action.type) {
    case RECEIVE_ERROR: {
      return {
        ...state,
        error: action.error.message,
        isFetching: false
      }
    }
    case REQUEST_DISTRICT_FLYERS: {
      return {
        ...state,
        isFetching: true
      }
    }
    case RECEIVE_ONE_SCHOOL_FLYER:
    case RECEIVE_ONE_DISTRICT_FLYER: {
      const flyer = action.flyer
      const flyerId = flyer.flyer_id

      return {
        ...state,
        isFetching: false,
        error: '',
        [flyerId]: flyer,
        allIds: R.uniq([...state.allIds, flyerId]),
        byCategory: {
          ...state.byCategory,
          [flyer.category]: {
            name: flyer.category,
            flyers: R.uniq([
              ...(state.byCategory[flyer.category]
                ? state.byCategory[flyer.category].flyers
                : []),
              flyerId
            ])
          }
        },
        allCategories: R.uniq([...state.allCategories, flyer.category])
      }
    }
    case RECEIVE_DISTRICT_FLYERS: {
      const flyers = action.flyers
      const byCategory = R.reduce(
        (accum, flyer) => ({
          ...accum,
          [flyer.category]: {
            name: flyer.category,
            flyers: R.uniq([
              ...(accum[flyer.category] ? accum[flyer.category].flyers : []),
              flyer.flyer_id
            ])
          }
        }),
        {},
        R.map(fId => action.flyers[fId], action.allFlyers)
      )
      const flyerArray = R.map(fId => flyers[fId], action.allFlyers)
      const flyerAudienceInfo = action.flyerAudienceInfo
      return {
        ...state,
        isFetching: false,
        error: '',
        lastUpdated: action.receivedAt,
        ...flyers,
        // The below line overwrites existing 'flyers.allIds', which overwrites
        // any flyers fetched specifically by Id. This currently serves to prevent
        // from showing approvers their non-approved flyer when hitting 'back' button.
        // If you change this to merge with existing, make sure to take the above
        // into account.
        allIds: action.allFlyers,
        byCategory: R.mergeDeepRight(state.byCategory, byCategory),
        allCategories: R.uniq([
          ...state.allCategories,
          ...R.map(R.prop('category'), flyerArray)
        ]),
        flyerAudienceInfo,
      }
    }
    case RETRIEVE_DISTRICT_FLYERS_FROM_CACHE:
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/shared/redux/flyers/reducer.js